/*******************************************************************************
* @license
* Copyright (c) 2016 - present Accedo. All Rights Reserved.
* 
* This source code, its use, and distribution, is subject to the terms
* and conditions of the applicable license agreement.
* 
* A navigation solution for VDK Web. (@accedo/vdkweb-navigation) 6.2.5
* 
*******************************************************************************/
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleNavigationUpdate = exports.getIsFocused = exports.forwardFocusIfNecessary = void 0;
var _navigationService = _interopRequireDefault(require("./navigationService"));
var _focusManager = _interopRequireDefault(require("./focusManager"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var _navigationService$Ev = _navigationService["default"].EventType,
  TraceFocus = _navigationService$Ev.TraceFocus,
  MarkFocus = _navigationService$Ev.MarkFocus,
  ContinueNavigation = _navigationService$Ev.ContinueNavigation;
var traceFocus = function traceFocus(eventData) {
  _navigationService["default"].trigger({
    eventType: TraceFocus,
    eventData: eventData
  });
};
var markFocus = function markFocus(nav) {
  _navigationService["default"].trigger({
    eventType: MarkFocus,
    eventData: {
      parentId: nav.parent,
      focusId: nav.id
    }
  });
};
var continueNavigation = function continueNavigation(direction) {
  _navigationService["default"].trigger({
    eventType: ContinueNavigation,
    eventData: direction
  });
};
var getDerivedNavigationData = function getDerivedNavigationData(navigationData, navId) {
  var currentFocus = navigationData.currentFocus,
    currentTraceFocus = navigationData.currentTraceFocus,
    click = navigationData.click,
    navigateFocus = navigationData.navigateFocus;
  var isFocused = currentFocus === navId;
  var isTraced = currentTraceFocus === navId;
  var navigate = null;
  var isClicked = false;
  if (isFocused) {
    if (currentTraceFocus) {
      return {};
    }
    if (navigateFocus) {
      navigate = navigateFocus;
    } else if (click) {
      isClicked = true;
    }
  } else if (isTraced) {
    navigate = navigateFocus;
  }
  var clickId = isClicked ? navigationData.clickId : undefined;
  return {
    isFocused: isFocused,
    isTraced: isTraced,
    isClicked: isClicked,
    navigate: navigate,
    clickId: clickId
  };
};
var continueNavigationFlow = function continueNavigationFlow(nav, navigate) {
  if (nav[navigate]) {
    _focusManager["default"].changeFocus(nav[navigate]);
    return;
  }
  traceFocus(nav.parent || null);
};
var isBlockedByInternal = function isBlockedByInternal(nav, navigate) {
  var _nav$internal, _nav$internal$navigat;
  return (_nav$internal = nav.internal) === null || _nav$internal === void 0 ? void 0 : (_nav$internal$navigat = _nav$internal[navigate]) === null || _nav$internal$navigat === void 0 ? void 0 : _nav$internal$navigat.call(_nav$internal);
};
var forwardFocus = function forwardFocus(_ref) {
  var nav = _ref.nav,
    lastFocus = _ref.lastFocus;
  if (nav.useLastFocus && lastFocus) {
    _focusManager["default"].changeFocus(lastFocus);
  } else {
    _focusManager["default"].changeFocus(nav.forwardFocus);
  }
};
var getIsFocused = function getIsFocused(_ref2) {
  var nav = _ref2.nav,
    focusId = _ref2.focusId;
  var comparedFocus = typeof focusId === 'undefined' ? _focusManager["default"].getCurrentFocus() : focusId;
  return !!nav.id && nav.id === comparedFocus;
};
exports.getIsFocused = getIsFocused;
var handleSkipNav = function handleSkipNav(_ref3) {
  var nav = _ref3.nav,
    newData = _ref3.newData;
  if (nav[newData.lastNavigation] || nav.parent) {
    continueNavigation(newData.lastNavigation);
  } else {
    _focusManager["default"].changeFocus(newData.lastFocusOnNavigation);
  }
};
var handleNavigationUpdate = function handleNavigationUpdate(_ref4) {
  var directionReassign = _ref4.directionReassign,
    nav = _ref4.nav,
    newData = _ref4.newData,
    onBlur = _ref4.onBlur,
    onClick = _ref4.onClick,
    onFocus = _ref4.onFocus,
    onUpdate = _ref4.onUpdate,
    prevData = _ref4.prevData,
    setLastFocus = _ref4.setLastFocus,
    getLastFocus = _ref4.getLastFocus;
  var clickId = newData.clickId,
    creatingTrail = newData.creatingTrail;
  if (creatingTrail) {
    setLastFocus(nav.useLastFocus ? newData.currentFocus : '');
    markFocus(nav);
    return;
  }
  var derivedData = getDerivedNavigationData(newData, nav.id);
  var derivedPrevData = getDerivedNavigationData(prevData, nav.id);
  var navigate = derivedData.navigate;
  if (_typeof(directionReassign) === 'object') {
    navigate = directionReassign[navigate] || navigate;
  }
  if (derivedData.isTraced) {
    if (isBlockedByInternal(nav, navigate)) {
      return;
    }
    continueNavigationFlow(nav, navigate);
    return;
  }
  if (navigate && !derivedPrevData.navigate) {
    if (isBlockedByInternal(nav, navigate)) {
      traceFocus(null);
      return;
    }
    continueNavigationFlow(nav, navigate);
    return;
  }
  if (derivedData.isClicked && clickId && clickId !== derivedPrevData.clickId) {
    var result = onClick();
    if (result) {
      return;
    }
  }
  var isFocused = getIsFocused({
    nav: nav
  });
  var prevIsFocused = getIsFocused({
    nav: nav,
    focusId: prevData.currentFocus
  });
  if (isFocused && !prevIsFocused) {
    if (nav.skip) {
      handleSkipNav({
        nav: nav,
        newData: newData
      });
      return;
    }
    if (nav.forwardFocus) {
      forwardFocus({
        nav: nav,
        lastFocus: getLastFocus()
      });
      return;
    }
    markFocus(nav);
  }
  if (isFocused && !prevIsFocused && onFocus) {
    onFocus();
  } else if (!isFocused && prevIsFocused && onBlur) {
    onBlur();
  }
  onUpdate();
};
exports.handleNavigationUpdate = handleNavigationUpdate;
var forwardFocusIfNecessary = function forwardFocusIfNecessary(_ref5) {
  var nav = _ref5.nav,
    prevNav = _ref5.prevNav,
    lastFocus = _ref5.lastFocus;
  var isFocused = getIsFocused({
    nav: nav
  });
  if (isFocused) {
    if (nav.skip) {
      handleSkipNav({
        nav: nav,
        newData: _navigationService["default"].getData()
      });
    } else if (nav.forwardFocus && (!prevNav || nav.forwardFocus !== prevNav.forwardFocus)) {
      forwardFocus({
        nav: nav,
        lastFocus: lastFocus
      });
    }
  }
};
exports.forwardFocusIfNecessary = forwardFocusIfNecessary;